import { Component, computed, inject, input } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import type { SelectedPeriodModelType } from "../../../models";
import { NationalStrategiesPerfService } from "../../../services/national-strategies-perf-service";
import { ItemSliderComponent } from "../item-slider/item-slider";
import { NationalStrategiesPerfCardComponent } from "../national-strategies-perf-card/national-strategies-perf-card";

@Component({
  selector: "adaa-national-strategies-performance",
  templateUrl: "./national-strategies-performance.html",
  styleUrl: "./national-strategies-performance.scss",
  imports: [TranslatePipe, NationalStrategiesPerfCardComponent, ItemSliderComponent],
})
export class NationalStrategiesPerformanceComponent {
  private readonly _nationalStrategiesPerfService = inject(NationalStrategiesPerfService);

  selectedPeriod = input<SelectedPeriodModelType>();

  directions = computed(() => this._nationalStrategiesPerfService.directions());

  periodLabel = computed(() => {
    const period = this.selectedPeriod();
    if (!period?.period) return "";
    return period.type === "year" ? `${period.period.year}` : `Q${period.period.quarter} ${period.period.year}`;
  });
}
